export const DE = {
    jobAdButton: 'Ich bin interessiert',
    entrypointTitle: 'Hast du eine Frage?',
    entrypointSubtitle: 'Nutzen Sie Stepstone KI, um alle Ihre Fragen zu dieser Rolle zu beantworten.',
    entrypointResumeButton: 'Zurück zum Chat',
    entrypointResumeSubtitle: 'Stelle Fragen zu diesem Job.',
    entrypointInputPlaceholder: 'Frag alles, was du wissen möchtest.',
    entrypointInputSuggestions: {
        location: 'Wo befindet sich {company}?',
        culture: 'Wie ist die Kultur bei {company}?',
        benefits: 'Welche Benefits kann ich erwarten?',
        vacation: 'Wie viel Urlaub habe ich?',
        inclusive: 'Ist {company} inklusiv?',
        careerDevelopment: 'Welche Karrieremöglichkeiten gibt es?',
    },
    entrypointSubHeading: 'Zum Beispiel...',
    ratePromptTitle: 'Bewerte die Qualität der Antwort',
    ratePromptSubtitle: 'Gibt einen Daumen hoch oder runter um dieses Feature zu verbessern.',
    feedbackConfirm: 'Danke für dein Feedback!',
    likeA11y: 'Gute Antwort',
    dislikeA11y: 'Schlechte Antwort',
    dislikeFormTitle: 'Teile dein Feedback',
    dislikeFormOptions: {
        1: 'Ergibt keinen Sinn',
        2: 'Unangemessen',
        3: 'Beantwortet die Frage nicht',
        4: 'Nicht hilfreich',
    },
    dislikeFormCancel: 'Abbrechen',
    dislikeFormSubmit: 'Absenden',
    feedbackThankYouMessage: 'Danke für dein Feedback!',
    feedbackLoadingMessage: 'Feedback-Optionen werden geladen...',
    feedbackErrorMessage: 'Feedback-Optionen konnten nicht geladen werden',
    csatPrompt: {
        boxHeadline: 'Möchtest du noch etwas fragen?',
        boxNoMoreQuestions: 'Nein, danke',
        boxMoreQuestions: 'Ja, ich habe weitere Fragen',
        smileys: {
            feedbackHeadline: 'Wie zufrieden warst du mit dem Gespräch?',
            rate1: 'Sehr unzufrieden',
            rate2: 'Unzufrieden',
            rate3: 'Neutral',
            rate4: 'Zufrieden',
            rate5: 'Sehr zufrieden',
        },
    },
    stStAi: 'Stepstone KI',
    stepstoneAiBadge: 'Stepstone AI',
    under18: 'Aus Sicherheitsgründen ist der Chat-Zugang auf Nutzer ab 18 Jahren beschränkt. Wir haben diese Funktion vorübergehend für Ihr Konto deaktiviert. In der Zwischenzeit können Sie weiterhin Stellenangebote und Unternehmensinformationen auf unserer Plattform durchsuchen.',
    errorAlert: 'Es tut uns leid, aber wir haben derzeit Probleme beim Laden des Chats. Du kannst entweder weiter warten oder es erneut versuchen.',
    errorTryAgain: 'Erneut versuchen',
    headerLink: 'Fragen zum Job?',
    askAQuestionWidgetText: 'Stelle eine Frage',
    disclaimerAI: 'BETA: KI-generiert aus Stellenanzeigen-Informationen',
    submitQuestion: 'Frage absenden',
    addAttachment: 'Anhang hinzufügen',
    betaIntroMessage: '**Stepstone AI – Beta**\n\nStepstone AI ist ein KI-gestützter Assistent. Sie interagieren mit einem automatisierten System.\nAntworten werden automatisch auf Basis der vom Arbeitgeber bereitgestellten Informationen generiert und können unvollständig oder fehlerhaft sein.',
    chatStorageNotice: 'Dieser Chat kann für einen begrenzten Zeitraum zu Zwecken der Qualitätssicherung und Verbesserung des AMA-Dienstes gemäß unserer Datenschutzrichtlinie gespeichert werden. Bitte teilen Sie keine sensiblen Informationen.',
    chatStorageNoticeLinkText: 'Datenschutzrichtlinie',
    chatStorageNoticeLinkUrl: 'https://www.stepstone.de/e-recruiting/rechtliches/datenschutzerklarung/',
    reportProblemLinkText: 'Problem melden',
    reportProblemLinkUrl: 'https://www.stepstone.de/e-recruiting/formular-zur-meldung-von-rechtswidrigen-inhalten/?reference={companyId}',
    welcomeQuestion: '**Was möchtest du wissen?**',
    errorHeading: '**Fehler**',
    technicalErrorMessage: 'Entschuldigung, es ist ein technischer Fehler aufgetreten. Bitte versuche es später erneut.',
    sessionLimitMessage: 'Du hast die Anzahl an Fragen aufgebraucht für die nächsten **30 Minuten**.',
    dailyLimitMessage: 'Du hast die Anzahl an Fragen für heute aufgebraucht. Morgen kannst du wieder Fragen stellen.',
    budgetLimitMessage: 'Stepstone KI macht eine kurze Pause und ist Anfang des nächsten Monats wieder verfügbar.',
    processing: 'Wird verarbeitet...',
    chatTitle: 'Stell deine Fragen zum Unternehmen',
};
